import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-23afa4c1.js';
import { d as defineCustomElement$5 } from './p-585462a7.js';
import { d as defineCustomElement$4 } from './p-c375e962.js';
import { d as defineCustomElement$3 } from './p-536c1b8e.js';
import { d as defineCustomElement$2 } from './p-0f8558ea.js';
import { b as bem } from './p-a05fe53c.js';

const cosmosOptionCss = ":host{display:block;max-width:100%;position:relative;width:100%}:host(:focus-visible){outline:none}:host(:focus-visible)::before{content:\"\";border-radius:calc(4px * 1.5);bottom:calc((4px + -4px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + -4px) * -1);position:absolute;right:calc((4px + -4px) * -1);top:calc((4px + -4px) * -1)}.cosmos-option{-ms-flex-align:center;align-items:center;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:default;display:-ms-flexbox;display:flex;gap:6px;-ms-flex-pack:justify;justify-content:space-between;margin:0;max-width:100%;padding:6px 12px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;--cosmos-text-color:var(--cosmos-option-color);--cosmos-text-font-family:var(--cosmos-option-font-family);--cosmos-text-font-size:var(--cosmos-option-font-size);--cosmos-text-font-style:var(--cosmos-option-font-style);--cosmos-text-font-weight:var(--cosmos-option-font-weight);--cosmos-text-letter-spacing:var(--cosmos-option-letter-spacing);--cosmos-text-line-height:var(--cosmos-option-line-height);--cosmos-text-text-transform:var(--cosmos-option-text-transform)}.cosmos-option__content{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;gap:var(--cosmos-option-gap, 6px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cosmos-option__icon{--cosmos-icon-color:#000F1E;-ms-flex:0 0 auto;flex:0 0 auto;height:18px;width:18px}.cosmos-option__label{overflow:hidden}.cosmos-option--selected{background:rgba(0, 15, 30, 0.05)}.cosmos-option--disabled{--cosmos-text-color:rgba(0, 15, 30, 0.45)}.cosmos-option--disabled .cosmos-option__icon{--cosmos-icon-color:rgba(0, 15, 30, 0.45)}.cosmos-option:hover:not(.cosmos-option--disabled){background:rgba(0, 15, 30, 0.05)}.cosmos-option--appearance-light .cosmos-option__icon{--cosmos-icon-color:#FFFFFF}.cosmos-option--appearance-light.cosmos-option--disabled{--cosmos-text-color:rgba(255, 255, 255, 0.45)}.cosmos-option--appearance-light.cosmos-option--disabled .cosmos-option__icon{--cosmos-icon-color:rgba(255, 255, 255, 0.45)}.cosmos-option--appearance-light:hover:not(.cosmos-option--disabled){background:rgba(255, 255, 255, 0.1)}.cosmos-option--appearance-light.cosmos-option--selected{background:rgba(255, 255, 255, 0.1)}.cosmos-option ::slotted([slot=prefix]){-ms-flex:0 0 auto;flex:0 0 auto;--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}";
const CosmosOptionStyle0 = cosmosOptionCss;

const generateClassNames = bem('cosmos-option');
const CosmosOption$1 = /*@__PURE__*/ proxyCustomElement(class CosmosOption extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.optionselectEvent = createEvent(this, "optionselect", 7);
        this.appearance = 'dark';
        this.disabled = false;
        this.selected = false;
        this.value = '';
        this.showCheckbox = false;
    }
    componentWillLoad() {
        const closestSelect = this.element.closest('cosmos-select');
        if (closestSelect === null || closestSelect === void 0 ? void 0 : closestSelect.hasAttribute('multiple')) {
            this.showCheckbox = true;
        }
    }
    mouseDownHandler() {
        if (this.disabled) {
            return;
        }
        this.optionselectEvent.emit({ value: this.value });
    }
    handleSelectedChange(newValue, currentValue) {
        if (newValue !== currentValue) {
            this.optionselectEvent.emit({ value: this.value });
        }
    }
    render() {
        var _a;
        return (h(Host, { key: '61d7da77ec203dd21e995638652ea33b3844ad23', role: "option", "aria-label": (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim(), "aria-selected": this.selected.toString(), "aria-disabled": this.disabled ? 'true' : undefined }, h("div", { key: '967167ca57998d55c06749f23a4ad117790e278c', class: generateClassNames({
                disabled: this.disabled,
                appearance: this.appearance,
                selected: this.selected,
            }), part: "base" }, h("div", { key: '0d7db0ab324a839014246ffa66f9cac89d35fa1e', class: generateClassNames('content') }, h("slot", { key: 'fa2aeffd9dac8523eeb6524194dbb7499aff1e83', "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { key: '0f96a86aafc67a7b53a4976ffa5f8ff57d605b27', appearance: this.appearance, exportparts: "base: label", class: generateClassNames('label'), size: "small", clamp: 1 }, h("span", { key: '106f21f13ef621282490441770470bf7a62f4403' }, h("slot", { key: '336cab6ef1c5ed6544654ba929eb070b0e440377' })))), this.showCheckbox ? (h("cosmos-checkbox", { checked: this.selected, class: generateClassNames('icon'), tabIndex: -1 })) : this.selected ? (h("cosmos-icon-checkmark", { class: generateClassNames('icon') })) : (h("div", { class: generateClassNames('icon') })))));
    }
    get element() { return this; }
    static get watchers() { return {
        "selected": ["handleSelectedChange"]
    }; }
    static get style() { return CosmosOptionStyle0; }
}, [1, "cosmos-option", {
        "appearance": [513],
        "disabled": [516],
        "selected": [516],
        "value": [513],
        "showCheckbox": [32]
    }, [[1, "mousedown", "mouseDownHandler"]], {
        "selected": ["handleSelectedChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-option", "cosmos-checkbox", "cosmos-icon-checkmark", "cosmos-icon-warning", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-option":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosOption$1);
            }
            break;
        case "cosmos-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "cosmos-icon-checkmark":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-icon-warning":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosOption = CosmosOption$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosOption, defineCustomElement };
